import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createTeacher } from '@services/registry';

export function useCreateTeacher({ tenantId }) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ email, password, profile }) => {
            return await createTeacher({ tenantId, email, password, profile });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['teachers', tenantId] });
            qc.invalidateQueries({ queryKey: ['teacherKpis', tenantId] });
        },
    });
}

